<script>
import NoRecordFound from '@/src/components/_norecord-found'
import CustomMessage from '@/src/components/_custom-message.vue'

export default {
    name: 'WatchlistDetails',
    components: {
        NoRecordFound,
        CustomMessage,
    },
    props: {
        watchlistTableHeaderName: {
            type: String,
            default: '',
        },
        watchlistItems: {
            type: Array,
            default: () => [],
        },
        resultItems: {
            type: Array,
            default: () => [],
        },
        showPepColumn: {
            type: Boolean,
            default: false,
        },
        watchlistError: {
            type: String,
            default: null,
        },
        bridgerError: {
            type: String,
            default: null,
        },
        ascError: {
            type: String,
            default: null,
        },
        isBatchOrder: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            watchlistTableFields: [
                ...(this.isBatchOrder ? [{
                    key: 'Reference',
                    label: 'Reference #',
                    thClass: ['text-center', 'align-middle'],
                    tdClass: ['text-center', 'align-middle'],
                    thStyle: { width: '5%' },
                }] : []),
                {
                    key: 'Name',
                    label: this.watchlistTableHeaderName,
                    thClass: 'align-middle',
                    tdClass: 'textTruncatee',
                    thStyle: { width: '20%' },
                },
                {
                    key: 'ofac',
                    label: 'OFAC',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                {
                    key: 'epls',
                    label: 'EPLS/SAM',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                {
                    key: 'hudldp',
                    label: 'HUD/LDP',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                {
                    key: 'fhfaScpl',
                    label: 'FHFA SCPL',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                {
                    key: 'sanctions',
                    label: 'Sanctions',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                {
                    key: 'fmel',
                    label: 'FMEL',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                {
                    key: 'custom',
                    label: 'Custom',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '6%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                // {
                //     key: 'mrb',
                //     label: 'MRB ¹',
                //     thClass: ['text-center', 'align-middle'],
                //     thStyle: { width: '7%' },
                //     tdClass: ['text-center', 'align-middle'],
                // },
                {
                    key: 'pep',
                    label: 'PEP¹',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '7%' },
                    tdClass: ['text-center', 'align-middle'],
                },
                // {
                //     key: 'adverseMedia',
                //     label: 'Adverse Media',
                //     thClass: ['text-center', 'align-middle'],
                //     thStyle: { width: '7%' },
                //     tdClass: ['text-center', 'align-middle'],
                // },
                {
                    key: 'others',
                    label: 'Others',
                    thClass: ['text-center', 'align-middle'],
                    thStyle: { width: '6%' },
                    tdClass: ['text-center', 'align-middle'],
                }
            ],
            watchlistTableItems: [
                'ofac',
                'epls',
                'hudldp',
                'fhfaScpl',
                'sanctions',
                'fmel',
                'custom',
                'mrb',
                'pep',
                'adverseMedia',
                'others',
                'nmls',
                'asc'
            ],
            PepWatchlist: 'PEP',
            MrbWatchlist: 'MRB',
        };
    },
    computed: {
        displayedResultItems() {
            return this.showPepColumn
                ? this.resultItems
                : this.resultItems.filter(item => item.Watchlist !== this.PepWatchlist)
        },
        filteredWatchlistTableFields() {
            return this.watchlistTableFields.filter(field => field.key !== 'pep' || this.showPepColumn)
        },
    },
    methods: {
        turnBold(str, substr) {
            return str ? str.replaceAll(substr, substr.bold()) : ''
        },
    },
}
</script>

<template>
    <div>
        <b-row>
            <b-col class="mx-2">
                <div class="d-flex justify-content-between mt-1 mb-3">
                    <div class="d-flex">
                        <BaseELabel
                            v-if="showPepColumn"
                            class="m-0"
                            label="¹ PEP - Politically Exposed Persons"
                        />
                    </div>
                    <div class="d-flex watchlistActionsContainer">
                        <div class="watchlistAction">
                            <img src="@assets/images/check-icon.svg"/>
                            <span>No action required</span>
                        </div>
                        <div class="watchlistAction">
                            <img src="@assets/images/warning-icon.svg"/>
                            <span>Action required</span>
                        </div>
                        <div class="watchlistAction">
                            <img src="@assets/images/remove-icon.svg"/>
                            <span>Not applicable</span>
                        </div>
                        <div class="watchlistAction">
                            <img src="@assets/images/lock-icon.svg"/>
                            <span>Not enabled</span>
                        </div>
                    </div>
                </div>
                <b-table
                    responsive
                    striped
                    bordered
                    :fields="filteredWatchlistTableFields"
                    :items="watchlistItems"
                    :class="{
                        'mb-0': !watchlistItems.length,
                        'watchlistTable': true,
                        'fraudReportHeaderTable': true,
                    }"
                >
                    <template v-slot:cell(Name)="row">
                        <div class="d-flex flex-column" :class="{ 'pl-4': row.item.Role === 'Employer' }">
                            <span class="px-2 pt-2 pb-1 roleTitleWatchlistTable">{{ row.item.Role }}</span>
                            <span class="px-2 pb-2">{{ row.item.Name }}</span>
                        </div>
                    </template>
                    <template
                        v-for="(entity, ind) in watchlistTableItems"
                        v-slot:[`cell(${entity})`]="row"
                    >
                        <div :key="ind" class="watchlistTableIconContainer" :class="{ 'watchlistTableWarningIconContainer': row.item[entity] === 1 }">
                            <span v-if="row.item[entity] === -1" >
                                <img src="@assets/images/lock-icon.svg"/>
                            </span>
                            <span v-else-if="row.item[entity] === 1" >
                                <img src="@assets/images/warning-icon.svg"/>
                            </span>
                            <span v-else-if="row.item[entity] === null">
                                <img src="@assets/images/remove-icon.svg"/>
                            </span>
                            <span v-else-if="row.item[entity] === 0">
                                <img src="@assets/images/check-icon.svg"/>
                            </span>
                        </div>
                    </template>
                </b-table>
                <NoRecordFound v-if="!watchlistItems.length"></NoRecordFound>
            </b-col>
        </b-row>
        <!-- Watchlist Results -->
        <b-row v-if="displayedResultItems.length || watchlistError !== null" class="mb-3 mt-1">
            <b-col class="mx-2">
                <BaseELabel class="mb-2" label="Watchlist Results" new-style />
                <div v-if="watchlistError === null">
                    <div v-if="bridgerError" class="border baseContentFont py-1 my-1 text-center">
                        {{ bridgerError }}
                    </div>
                    <div v-if="ascError" class="border baseContentFont py-1 my-1 text-center">
                        {{ ascError }}
                    </div>
                    <b-row
                        v-for="(item, index) in displayedResultItems"
                        :key="index"
                        class="border mx-0 baseContentFont py-2 watchListContainer"
                    >
                        <b-col md="4">
                            <div>
                                <BaseELabel class="my-0" label="Participant Name:" />
                                <span>&nbsp;{{ item.Name }}</span>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div>
                                <BaseELabel class="my-0" label="Entity Type:" />
                                <span>&nbsp;{{ item.Entitytype }}</span>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div>
                                <BaseELabel class="my-0" label="Watchlist Match:" />
                                <span>&nbsp;{{ item.Watchlist }}</span>
                            </div>
                        </b-col>
                        <b-col md="12">
                            <div>
                                <BaseELabel class="my-0" label="Details:" />
                                <!-- PEP watchlist details-->
                                <div v-if="item.Watchlist === PepWatchlist">
                                    <div>
                                        Match Name: {{ item.EntityName || 'No Information Found' }} |
                                        <BaseELabel
                                            class="mx-1"
                                            :label="`Match Score : ${item.EntityScore !== null && item.EntityScore !== undefined ? item.EntityScore : 'No Information Found'}`"
                                        />
                                        | Deceased Indicator : {{item.DeceasedIndicator}}
                                    </div>
                                    <div v-if="item.PepEntries.length">
                                        <div
                                            v-for="(pep, pepIndex) in item.PepEntries"
                                            :key="`pep-entry-${index}-${pepIndex}`"
                                        >
                                            Country: {{ pep.country || 'No Information Found' }} |
                                            Institution: {{ pep.institution || 'No Information Found' }} |
                                            Role: {{ pep.role || 'No Information Found' }} |
                                            Status: {{ pep.status || 'No Information Found' }}
                                        </div>
                                    </div>
                                    <div v-else>No Information Found</div>
                                </div>
                                <!-- Mrb watchlist details-->
                                <div v-else-if="item.Watchlist === MrbWatchlist">
                                    <div>
                                        Match Name: {{ item.EntityName }} |
                                        <BaseELabel :label="`Match Score : ${item.EntityScore}`"/>
                                    </div>
                                    <div
                                        v-for="(registration, registrationIndex) in item.MrbRegistrations"
                                        :key="`mrb-registration-${index}-${registrationIndex}`"
                                    >
                                        Registration Number:
                                        {{ registration.number || 'No Information Found' }} |
                                        Issuer:
                                        {{ registration.issuer || 'No Information Found' }}
                                    </div>
                                    <div v-if="!item.MrbRegistrations.length">
                                        Business Registration Number: No Information Found
                                    </div>
                                    <div>
                                        Address: {{ item.Address || 'No Information Found' }}
                                    </div>
                                    <div
                                        v-for="(source, sourceIndex) in item.MrbSources"
                                        :key="`mrb-source-${index}-${sourceIndex}`"
                                    >
                                        Source:
                                        <a
                                            :href="source.uri"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                        link to document
                                        </a>
                                    </div>
                                    <div v-if="!item.MrbSources.length">
                                        Source: No Information Found
                                    </div>
                                </div>
                                <div v-else class="reasonStyle">
                                    <!-- eslint-disable -->
                                    <div v-html="turnBold(item.Reason, '§')"></div>
                                    <!-- eslint-enable -->
                                    <div>Address: {{ item.Address }}</div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <CustomMessage v-else :custom-msg="watchlistError"/>
            </b-col>
        </b-row>

    </div>
</template>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
/* stylelint-disable selector-pseudo-element-no-unknown,selector-class-pattern, property-no-unknown, no-descending-specificity */
/* stylelint-disable-next-line */

.reasonStyle {
  line-height: 1.5rem;
  word-wrap: break-word;
  white-space: normal;
}

.watchListContainer:nth-child(odd) {
  background: $color-white;
}

.watchListContainer:nth-child(even) {
  background: $color-raisin-10;
}

.watchListContainer:nth-child(1) {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.watchListContainer:nth-last-child(1) {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.watchlistTableWarningIconContainer {
  background-color: $color-accent-error-30;
}

.watchlistTableIconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

::v-deep .watchlistTable>table {
  overflow: hidden;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;
}

::v-deep .watchlistTable>.table>thead>tr>th {
  padding: 8px;
}

::v-deep .watchlistTable>table>tbody>tr>td {
  height: 1px;
  padding: 0 !important;
}


.watchlistActionsContainer {
  gap: 24px;
}

.watchlistAction {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 20px;
  color: $color-raisin-100;
}

.roleTitleWatchlistTable {
  color: $color-raisin-70;
}
</style>
